import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white text-black border-t border-black px-6 py-8 text-xs uppercase tracking-wide font-bold">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center space-y-4">
        <p className="text-sm">© {new Date().getFullYear()} Amora. {t('footer.rights')}</p>
        
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <a href="/about" className="underline hover:no-underline">
            {t('footer.about')}
          </a>
          <a href="/contact" className="underline hover:no-underline">
            {t('footer.contact')}
          </a>
          <a href="/privacy" className="underline hover:no-underline">
            {t('footer.privacy')}
          </a>
          <a href="/terms" className="underline hover:no-underline">
            {t('footer.terms')}
          </a>
        </div>

        <p className="text-[10px] text-black opacity-60 max-w-md leading-snug">
          {t('footer.disclaimer')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
